import { BookOpenIcon, EyeIcon, DumbbellIcon, type LucideIcon } from 'lucide-react';

export interface MethodStep {
  n: string;
  title: string;
  icon: LucideIcon;
  text: string;
}

export const methodSteps: MethodStep[] = [
  {
    n: '1',
    title: 'Abre',
    icon: BookOpenIcon,
    text: 'Elige la sesión o el aspecto que quieres trabajar (técnica, táctica K1-K2, física, balón parado).'
  },
  {
    n: '2',
    title: 'Mira',
    icon: EyeIcon,
    text: 'Consulta los ejercicios, sus diagramas y las correcciones del entrenador. Todo en una página.'
  },
  {
    n: '3',
    title: 'Entrena',
    icon: DumbbellIcon,
    text: 'Llévalo directamente a la pista.'
  }
];
